import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import { SFArrowBackIcon, SFNavigateNext } from "../icons";
import getStyled from "../../hooks/getStyled";
import Link from "@mui/material/Link";

const { styled } = getStyled();

const CustomTextLinkTypography = styled(SFTypography)(({ theme }) => ({
  color: theme.palette.blue500.main,
  fontSize: "12px",
  lineHeight: "14px",
  letterSpacing: "1px",
}));

const CustomBody2BoldTypography = styled(SFTypography)(({ theme }) => ({
  color: theme.palette.grey450.main,
  lineHeight: "14px",
  letterSpacing: "1px",
}));

const SFInPageBreadcrumb = ({ backLabel, backUrl, label, onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(backUrl);
    }
  };

  return (
    <SFStack spacing={0.625} direction="row" alignItems="center">
      <SFArrowBackIcon color="blue500" size="xsmall" />
      <Link
        component="button"
        underline="hover"
        onClick={handleClick}
        sx={(theme) => ({
          "&:hover": {
            textDecorationColor: theme.palette.blue500.main,
          },
        })}
      >
        <CustomTextLinkTypography variant="textLink">
          {backLabel}
        </CustomTextLinkTypography>
      </Link>
      <SFNavigateNext color="grey300" size="xsmall" />
      <CustomBody2BoldTypography variant="body2bold">
        {label}
      </CustomBody2BoldTypography>
    </SFStack>
  );
};

export default SFInPageBreadcrumb;

SFInPageBreadcrumb.propTypes = {
  /**
   * The label for the back button.
   */
  backLabel: PropTypes.string,
  /**
   * The URL to navigate to when the back button is clicked.
   */
  backUrl: PropTypes.string,
  /**
   * The label for the current page.
   */
  label: PropTypes.string,
  /**
   * The function to call when the back button is clicked. If not provided, the back button will navigate to the backUrl.
   */
  onClick: PropTypes.func,
};

SFInPageBreadcrumb.defaultProps = {
  backUrl: "/",
};
